import { doc, setDoc } from "firebase/firestore/lite";
import { getDoc } from "firebase/firestore/lite";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase.config"; 

function EditProduct() {
    const edit = useParams()
    console.log(edit.id);


    const [ preValue, setPreValue ] = useState({})
    console.log(preValue);

//FETCH EDIT DATA..
    useEffect(()=>{
      async function fetchEditData() {
        
        const docRef = doc(db, "products", edit.id )
        const data = await getDoc(docRef);
        
        const result = { ...data.data(), id: data.id };
            setPreValue(result)
            console.log(result);
        
        return 0;
        
      }
      fetchEditData()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    console.log(preValue.title,preValue.price)
    const k= preValue.title
    console.log(k);
    const [formValues, setFormValues] = useState({
        title: "",
        price: 0,
        category: "",
        image:  "",
        description: "",
        unavailable: false,
      });

//SET FORM VALUE
      useEffect(() => {
        
          setFormValues(prevState => ({
            ...prevState,
            title: preValue.title,
            price: preValue.price,
            category: preValue.category,
            image:  preValue.image,
            description: preValue.description,
            unavailable: preValue.unavailable,
          }));
        
      }, [preValue]);

    console.log(formValues)

//WHEN SUBMITTING..
      const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {
          await setDoc(doc(db, "products", edit.id), formValues); // Update the EditData document with the form data
          console.log("Document updated successfully!");
        } catch (error) {
          console.error("Error updating document: ", error);
        }
      };


  return (
    <div className="px-14">
      <div className="bg-slate-800 p-6 px-12 rounded-xl">
        <p className="text-center py-3 text-blue-500 text-lg font-bold tracking-widest">EDIT PRODUCT</p>
        <form className="text-center" onSubmit={handleFormSubmit} >
          <div className="mb-6">
            <label
              for="text"
              className="block mb-2 text-sm font-medium  text-slate-400 text-center"
            >
              Name
            </label>
            <input
              type="text"
              id="title"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Product Name"
              required
              value={formValues.title}
                onChange={(event) =>
                 setFormValues({ ...formValues, title: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="price"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Price
            </label>
            <input
              type="number"
              id="price"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.price}
                onChange={(event) =>
                setFormValues({ ...formValues, price: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="category"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Category
            </label>
            <input
              type="text"
              id="category"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.category}
                onChange={(event) =>
                setFormValues({ ...formValues, category: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="category"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Image
            </label>
            <input
              type="text"
              id="image"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              placeholder="Add image link"
              value={formValues.image}
                onChange={(event) =>
                setFormValues({ ...formValues, image: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="Description"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Description
            </label>
            <input
              type="tex"
              id="description"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.description}
                onChange={(event) =>
                setFormValues({ ...formValues, description: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <div className="items-center h-5 text-center">
              <label className="relative inline-flex items-center mb-4 cursor-pointer">
                <input type="checkbox"  className="sr-only peer"
                  value={formValues.unavailable}
                  onChange={(event) => {
                  setFormValues({ ...formValues, unavailable: event.target.checked ? true : false })
                    console.log(event.target.checked)}
                  } />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                <span className="ml-3 text-sm font-medium text-slate-400">
                  Item Unavailable
                </span>
              </label>
            </div>
            
          </div>
          
          <button
            type="submit"
            className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"

          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditProduct;
